import { useCallback, useMemo } from "react"
import { useSunburstGraphOption } from "./options"
import { useSunburstGraphModel } from "./model"
import { numericValueFormat } from "../../common"

type useSunburstGraphRenderOptionProps<T> = {
	graphOption: ReturnType<typeof useSunburstGraphOption<T>>
	graphData: ReturnType<typeof useSunburstGraphModel<T>>
}
export const useSunburstGraphRenderOption = <T,>({
	graphOption: {
		axisDef, valueDef
	},
	graphData
}: useSunburstGraphRenderOptionProps<T>) => {
  const labelFormatter = useMemo(
    () => valueDef?.unit ? `{b}\n{c}${valueDef.unit}` : undefined,
    [valueDef]
  )
  const valueFormatter = useCallback(
    (value: number | string) => numericValueFormat(value, 1, valueDef?.unit),
    [valueDef]
  )
	const levels = useMemo(
		() => axisDef?.categoryTitle ? [
			{ r: '30%', label: { rotate: 0 } },
			{ r0: '30%', r: '65%', label: { rotate: 0 } },
			{ r0: '65%', label: { formatter: '{b}' } }
		] : [
			{ r: '30%', label: { rotate: 0 } },
			{ r0: '30%', label: { rotate: 0 } }
		],
		[axisDef]
	)
	return {
		//animation: false,
		tooltip: {
			trigger: 'item',
			valueFormatter
		},
		series: [{
			type: 'sunburst',
			selectedMode: 'single',
			radius: [0, '90%'],
			label: {
				rotate: 'radial',
				show: true,
				formatter: labelFormatter
			},
			levels,
			data: graphData?.renderData || []
		}],
		textStyle: {
			fontFamily: 'Noto Sans JP,sans-serif'
		}
	}
}